export default __webpack_public_path__ + "e889effd7ceeecdb5f830935ce09fb18.svg";